import { BaseProxy, type ProxyMethods } from '@/proxies/Proxy'

export default class ProxyLogProxy extends BaseProxy implements ProxyMethods {
  public endpoint = 'proxy-logs'

  getList(params: URLSearchParams) {
    return this.submit('get', `/${this.endpoint}?${params}`)
  }
}
